// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { IndustryHint } from './industryHint.zod.ts';
import { IndustryRef } from './industryRef.zod.ts';
import { PersonRef } from './personRef.zod.ts';

export const IdeaRowOut = zod.object({
  "author": PersonRef,
  "confidence": zod.union([zod.int(),zod.null()]),
  "created_at": zod.iso.datetime({"offset":true}),
  "disposition": zod.enum(['active', 'parked', 'archived']),
  "id": zod.uuid(),
  "industry": zod.union([IndustryRef,zod.null()]),
  "industry_hint": zod.union([IndustryHint,zod.null()]).optional(),
  "industry_source": zod.union([zod.enum(['submitter', 'ai', 'admin']),zod.null()]),
  "research_status": zod.enum(['queued', 'researching', 'scored', 'failed']),
  "scores": zod.record(zod.string(), zod.union([zod.int(),zod.null()])),
  "title": zod.string(),
  "total": zod.union([zod.number(),zod.null()]),
  "verdict": zod.union([zod.enum(['go', 'conditional_go', 'no_go']),zod.null()])
});

export type IdeaRowOut = zod.input<typeof IdeaRowOut>;
export type IdeaRowOutOutput = zod.output<typeof IdeaRowOut>;
